import deepMerge from 'deepmerge';
import { converge } from 'ramda';
import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { LANDING_PAGE } from 'app/features/deltaConfig/constants';
import { pickState, pathOrFromPayload } from 'app/reducers/helpers';

const initialState = {
  imageUrl: `${window.etp.config.assetsUrl}img/landing/hero_bg.png`,
  imageUrl2X: `${window.etp.config.assetsUrl}img/landing/hero_bg@2x.png 2x`,
  titleKey: 'coupon_landing_freetrial_heroblock_title_testpartner_v1',
  subTitleKey: 'coupon_landing_freetrial_heroblock_subtitle_testpartner_v1',
  legalCopyKey: 'coupon_landing_freetrial_heroblock_legal_copy_default',
  tosLink: 'https://www.crunchyroll.com/tos',
};

const heroBlock = handleActions(
  {
    [FETCH_DELTA_CONFIG_SUCCESS]: converge(deepMerge, [
      pickState,
      pathOrFromPayload({}, [LANDING_PAGE, 'heroBlock']),
    ]),
  },
  initialState,
);

const landing = combineReducers({ heroBlock });

export { initialState, heroBlock, landing };
